import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarRoutingModule } from './navbar-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NavbarComponent } from './navbar.component';
import { SharedModule } from '../shared/shared.module';
import { HomepageComponent } from '../homepage/homepage.component';
import { AboutComponent } from '../about/about.component';
import { HistoryComponent } from '../history/history.component';

import { AwardsComponent } from '../awards/awards.component';
import { RulesComponent } from '../rules/rules.component';
import { ArchersComponent } from '../archers/archers.component';
import { AchievementsComponent } from '../achievements/achievements.component';
import { CalanderComponent } from '../calander/calander.component';

import { NewsComponent } from '../news/news.component';
import { ComplianceComponent } from '../compliance/compliance.component';
import { JudgesComponent } from '../judges/judges.component';
import { NewsDetailComponent } from '../news-detail/news-detail.component';
import { ExecutiveCommiteeComponent } from '../executive-commitee/executive-commitee.component';
import { CommittesComponent } from '../committes/committes.component';
import { GcComponent } from '../gc/gc.component';
import { AnnualAccountsComponent } from '../annual-accounts/annual-accounts.component';
import { ResultsComponent } from '../results/results.component';
import { EventsComponent } from '../events/events.component';
import { EventDetailsComponent } from '../event-details/event-details.component';
import { FameHallComponent } from '../fame-hall/fame-hall.component';
import { GalleryComponent } from '../gallery/gallery.component';
import { RecordComponent } from '../record/record.component';
import { MemberUnitComponent } from '../member-unit/member-unit.component';
import { RTIComponent } from "../rti/rti.component";
import { GovermentSectionComponent } from "../goverment-section/goverment-section.component";
import { MiscellaneousSanctionalOrdersComponent } from "../miscellaneous-sanctional-orders/miscellaneous-sanctional-orders.component";
import { KheloIndiaSanctionalOrdersComponent } from "../khelo-indian-sanctional-orders/khelo-indian-sanctional-orders.component";
import { CoachingCampSanctionalOrdersComponent } from "../coaching-camp-sanctional-orders/coaching-camp-sanctional-orders.component";
import { NationalSanctionalOrdersComponent } from "../national-sanctional-orders/national-sanctional-orders.component";
import { InternationalSanctionalOrdersComponent } from "../international-sanctional-orders/international-sanctional-orders.component";
import { HarassmentComponent } from "../sexual-harassment/harassment.component";

@NgModule({
  declarations: [
    NavbarComponent,
    HomepageComponent,
    AboutComponent,
    HistoryComponent,
    AwardsComponent,
    RulesComponent,
    ArchersComponent,
    AchievementsComponent,
    CalanderComponent,
    NewsComponent,
    ComplianceComponent,
    JudgesComponent,
    NewsDetailComponent,
    ExecutiveCommiteeComponent,
    CommittesComponent,
    GcComponent,
    AnnualAccountsComponent,
    ResultsComponent,
    EventsComponent,
    EventDetailsComponent,
    FameHallComponent,
    GalleryComponent,
    RecordComponent,
    MemberUnitComponent,
    RTIComponent,InternationalSanctionalOrdersComponent,NationalSanctionalOrdersComponent,CoachingCampSanctionalOrdersComponent,KheloIndiaSanctionalOrdersComponent,MiscellaneousSanctionalOrdersComponent,HarassmentComponent
  ],
  imports: [
    CommonModule,
    NavbarRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class NavbarModule {}
